@if (paper()) {

  <mat-card class="research-paper-card">
    <mat-card-header>
      <mat-card-title>{{ paper()!.title }}</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="info">
        <mat-icon>menu_book</mat-icon>
        <span>{{ paper()!.venue }} - {{ paper()!.year }} </span>
      </div>

      <div class="info">
        <mat-icon>lightbulb</mat-icon>
        <span> <b>{{ paper()!.citationCount || 0 }}</b> Citations</span>
        <span> <b>{{ paper()!.referenceCount || 0 }}</b> References</span>
      </div>

      <div class="info">
        <mat-icon>group</mat-icon>
        <span>{{ paper()!.authors }}</span>
      </div>
    </mat-card-content>
  </mat-card>
}
